// Components==============
import GridFiller from 'components/UI/GridFiller/GridFiller';
import { useRedux } from 'hooks/useRedux';
import ReflectionItem from 'pages/Growth/Reflect/components/ReflectionItem/ReflectionItem';
import React, { useContext } from 'react';
import { ReflectContext } from '../Reflect';
import './Views.module.scss';
// =========================

export default function GroupView() {
  const { checkpointGroup, wrapperRef } = useContext(ReflectContext);

  // filter out checkpoint
  const activities = checkpointGroup?.filter((group) => group.process_id !== 3);
  const checkpoint = checkpointGroup?.find((group) => group.process_id === 3);
  const userId = useRedux((state) => state.authentication?.user?.id);

  const checkpointDone = useRedux((state) => {
    const reflection = state.reflection?.entities.allIds.map(
      (id) => state.reflection?.entities.byId[id]
    );

    const uncompletedCheckpoints = activities?.map((a) => {
      const reflectionItem = reflection?.find(
        (r) => r?.project_process_id === a.id && r.created_by === userId
      );

      // reflection doesn't exists
      if (!reflectionItem) return true;
      // reflection exists, but is not completed
      return !!(!reflectionItem.finished && reflectionItem.contributed);
    });

    return !uncompletedCheckpoints?.includes(true);
  });

  return (
    <div styleName="wrapper" ref={wrapperRef}>
      {activities?.map((activity) => (
        <ReflectionItem activity={activity} key={activity.id} />
      ))}
      {!!checkpoint && (
        <ReflectionItem activity={checkpoint} checkpointDone={checkpointDone} />
      )}
      <GridFiller />
    </div>
  );
}
